<template>
  <v-dialog width="600" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn icon color="grey" v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
    </template>
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        Modifica Specie
      </v-card-title>
      <v-card-text>
        <v-row justify="center" class="mb-2">
          <v-col cols="4" class="">
            <v-card
              class="portrait d-flex justify-center"
              :img="image_box"
              height="150"
              width="150"
              @click="$refs.input.click()"
            >
              <input
                type="file"
                style="display: none"
                @change="onFileChange($event)"
                ref="input"
              />
            </v-card>
          </v-col>
          <v-col cols="8">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="nome"
                  outlined
                  label="Nome"
                  prepend-inner-icon="mdi-leaf"
                  hide-details
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="nome_sc"
                  outlined
                  label="Nome Scientifico"
                  prepend-inner-icon="mdi-flask-empty"
                  hide-details
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              v-model="esposizione"
              :items="esposizone_list"
              item-text="text"
              item-value="value"
              label="Esposione"
              prepend-inner-icon="mdi-umbrella-beach"
              outlined
              hide-details
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="richiesta_idr"
              :items="richiesta_idr_list"
              item-text="text"
              item-value="value"
              label="Richiesta Idrica"
              prepend-inner-icon="mdi-watering-can"
              hide-details
              outlined
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="manutenzione"
              :items="manutenzione_list"
              item-text="text"
              item-value="value"
              label="Manutenzione"
              prepend-inner-icon="mdi-heart"
              hide-details
              outlined
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="propagazione"
              :items="propagazione_list"
              item-text="text"
              item-value="value"
              label="Tipo Propagazione"
              prepend-inner-icon="mdi-seed"
              hide-details
              outlined
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model.number="tempo_vendita"
              type="number"
              min="0"
              outlined
              label="Settimane Trapianto → Vendita"
              prepend-inner-icon="mdi-calendar-clock"
              hide-details
            />
          </v-col>
          <v-col>
            <v-switch v-model="resistenza" inset label="Resistente al Gelo" />
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col> Periodo di Fioritura </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(1) ? 'green' : 'grey'"
              @click="setMonth(1)"
              >Gen</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(2) ? 'green' : 'grey'"
              @click="setMonth(2)"
              >Feb</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(3) ? 'green' : 'grey'"
              @click="setMonth(3)"
              >Mar</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(4) ? 'green' : 'grey'"
              @click="setMonth(4)"
              >Apr</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(5) ? 'green' : 'grey'"
              @click="setMonth(5)"
              >Mag</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(6) ? 'green' : 'grey'"
              @click="setMonth(6)"
              >Giu</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(7) ? 'green' : 'grey'"
              @click="setMonth(7)"
              >Lug</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(8) ? 'green' : 'grey'"
              @click="setMonth(8)"
              >Ago</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(9) ? 'green' : 'grey'"
              @click="setMonth(9)"
              >Set</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(10) ? 'green' : 'grey'"
              @click="setMonth(10)"
              >Ott</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(11) ? 'green' : 'grey'"
              @click="setMonth(11)"
              >Nov</v-btn
            >
          </v-col>
          <v-col cols="2" class="pa-1">
            <v-btn
              block
              outlined
              :color="isSelected(12) ? 'green' : 'grey'"
              @click="setMonth(12)"
              >Dic</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          color="green"
          :loading="loading_salva"
          :disabled="!nome || !nome_sc"
          @click="invia_specie()"
          ><v-icon class="mr-2">mdi-content-save</v-icon>Salva</v-btn
        >
        <v-btn text color="grey" @click="dialog = false">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    specie: Object,
  },
  data() {
    return {
      dialog: false,
      nome: this.specie.nome,
      nome_sc: this.specie.nome_sc,
      esposizone_list: [
        { value: 0, text: "Non Definito" },
        { value: 1, text: "Ombra" },
        { value: 2, text: "Mezz'ombra" },
        { value: 3, text: "Pieno Sole" },
      ],
      richiesta_idr_list: [
        { value: 0, text: "Non Definito" },
        { value: 1, text: "Bassa" },
        { value: 2, text: "Media" },
        { value: 3, text: "Alta" },
      ],
      manutenzione_list: [
        { value: 0, text: "Non Definito" },
        { value: 1, text: "Bassa" },
        { value: 2, text: "Media" },
        { value: 3, text: "Alta" },
      ],
      propagazione_list: [
        { value: 1, text: "Seme" },
        { value: 2, text: "Talea" },
      ],
      months: this.specie.mesi_fioritura,
      esposizione: this.specie.exposition,
      richiesta_idr: this.specie.water_request,
      resistenza: this.specie.frost_resist,
      manutenzione: this.specie.manutenzione,
      propagazione: this.specie.propagazione,
      tempo_vendita: this.specie.tempo_vendita ?? null,
      loading_salva: false,
      file: null,
      image_box:
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        this.specie.id +
        "/img?md5=" +
        this.specie.img_md5,
    };
  },
  watch: {
    "specie.tempo_vendita"(val) {
      this.tempo_vendita = val ?? null;
    },
  },
  methods: {
    setMonth(month) {
      if (this.months.includes(month)) {
        this.months = this.months.filter((item) => item != month);
      } else {
        this.months.push(month);
      }
    },
    isSelected(month) {
      return this.months.includes(month);
    },
    onFileChange(e) {
      this.file = e.target.files[0];
      this.createImage(this.file);
    },
    createImage(file) {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          this.image_box = reader.result;
        },
        false
      );
      reader.readAsDataURL(file);
    },
    invia_specie() {
      this.loading_salva = true;
      this.$store
        .dispatch("edit_specie", {
          id_specie: this.specie.id,
          nome: this.nome,
          nome_sc: this.nome_sc,
          exposition: this.esposizione,
          water_request: this.richiesta_idr,
          frost_resist: this.resistenza,
          manutenzione: this.manutenzione,
          mesi_fioritura: this.months,
          propagazione: this.propagazione,
          tempo_vendita: this.tempo_vendita,
        })
        .then((res) => {
        if (this.file) {
          let formData = new FormData();
          formData.append("file", this.file);
          this.$store
            .dispatch("nuova_img_specie", {
              id_specie: res.id,
              formData: formData,
            })
            .then(() => {
              this.loading_salva = false;
              this.dialog = false;
            });
        } else {
          this.loading_salva = false;
          this.dialog = false;
        }
      });
    },
  },
};
</script>
